/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';
export class Caixa {
  constructor () {
    this.caixa_id = uuidV4()
    this.empresa_id = sessionStorage.getItem('empresa_id')
    this.data =''
    // this.conta_id =''
    // this.saldo_inicial =0
    this.status ='A'
    this.observacao =''
    this.movimentos_caixa =[]


  }
}
